import { useStaticQuery, graphql } from 'gatsby'

export function useDataCompanyNumbers() {
    const data = useStaticQuery(graphql`
        {
            sectionTitle: datoCmsRenshinPageAbout(title: { eq: "Numbers: Title" }, locale: { eq: "hy" }) {
                value
            }

            investmentsTitle: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 1, title" }, locale: { eq: "hy" }) {
                value
            }

            investmentsText: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 1, text" }, locale: { eq: "hy" }) {
                value
            }

            investmentsItemTitle_1: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 2, title" }, locale: { eq: "hy" }) {
                value
            }

            investmentsItemText_1: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 2, text" }, locale: { eq: "hy" }) {
                value
            }

            investmentsItemTitle_2: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 3, title" }, locale: { eq: "hy" }) {
                value
            }

            investmentsItemText_2: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 3, text" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsTitle: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 4, title" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsText: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 4, text" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsItemTitle_1: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 5, title" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsItemText_1: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 5, text" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsItemTitle_2: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 6, title" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsItemText_2: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 6, text" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsItemTitle_3: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 7, title" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsItemText_3: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 7, text" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsItemTitle_4: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 8, title" }, locale: { eq: "hy" }) {
                value
            }

            apartmentsItemText_4: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 8, text" }, locale: { eq: "hy" }) {
                value
            }
        }
    `)

    return data
}
